import { useState } from "react";
import { technologies } from "./Technologies";
import "./Techs.css";

const Techs = () => {
    const [Hover, setHover] = useState({});
    return (
        <section className='technologies'>
            <h1>Technologies I use</h1>
            <div className='techs' id='container'>
                {technologies.map((Tech, idx) => {
                    return (
                        <div key={idx} className='techs-col'>
                            <div
                                style={{
                                    display: Hover[Tech.name] ? "block" : "none",
                                }}
                                className='tech-name'>
                                {Tech.name}
                            </div>
                            <Tech.Logo
                                onMouseLeave={() =>
                                    setHover((h) => ({
                                        ...h,
                                        [Tech.name]: false,
                                    }))
                                }
                                onMouseEnter={() =>
                                    setHover((h) => ({
                                        ...h,
                                        [Tech.name]: true,
                                    }))
                                }
                                style={{
                                    color: Hover[Tech.name] ? Tech.color : "rgb(151, 151, 151)",
                                    fill: Hover[Tech.name] ? Tech.color : "rgb(151, 151, 151)",
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default Techs;
